export default {
  namespaced: true,

  state: {
    notifications: [],
  },

  mutations: {
    ADD_NOTIFICATION(state, notification) {
      state.notifications.push({
        id: Date.now() + Math.random(), // ID único
        timestamp: Date.now(),
        ...notification,
      });
    },

    REMOVE_NOTIFICATION(state, id) {
      const index = state.notifications.findIndex((n) => n.id === id);
      if (index !== -1) {
        state.notifications.splice(index, 1);
      }
    },

    CLEAR_ALL(state) {
      state.notifications = [];
    },
  },

  actions: {
    /**
     * Muestra una notificación de éxito
     * @param {string} message - Mensaje a mostrar
     * @param {number} duration - Duración en ms (0 = permanente)
     */
    success({ commit }, { message, title = "Éxito", duration = 4000 }) {
      commit("ADD_NOTIFICATION", {
        type: "success",
        title,
        message,
        duration,
      });
    },

    /**
     * Muestra una notificación de error
     */
    error(
      { commit },
      {
        message,
        title = "Error",
        duration = 6000,
        contactSupport = false,
        errorDetails = null,
      }
    ) {
      commit("ADD_NOTIFICATION", {
        type: "danger",
        title,
        message,
        duration,
        contactSupport,
        errorDetails,
      });
    },

    /**
     * Muestra una notificación de advertencia
     */
    warning({ commit }, { message, title = "Advertencia", duration = 5000 }) {
      commit("ADD_NOTIFICATION", {
        type: "warning",
        title,
        message,
        duration,
      });
    },

    /**
     * Muestra una notificación informativa
     */
    info({ commit }, { message, title = "Información", duration = 4000 }) {
      commit("ADD_NOTIFICATION", {
        type: "info",
        title,
        message,
        duration,
      });
    },

    /**
     * Remueve una notificación específica
     */
    remove({ commit }, id) {
      commit("REMOVE_NOTIFICATION", id);
    },

    /**
     * Limpia todas las notificaciones
     */
    clearAll({ commit }) {
      commit("CLEAR_ALL");
    },
  },

  getters: {
    notifications: (state) => state.notifications,
    count: (state) => state.notifications.length,
  },
};
